import React, { useContext, useEffect } from 'react';
import { GlobalContext } from '../../context/GlobalContext';
import { ToastContainer } from 'react-toastify';
import { useParams } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

function Form() {
    let { IdData } = useParams();
    const { state, handlers } = useContext(GlobalContext);
    const { input, setInput } = state;
    const { handleInput, handleSubmit } = handlers;

    useEffect(() => {
        if (IdData !== undefined) {
            axios.get(`https://dev-example.sanbercloud.com/api/job-vacancy/${IdData}`)
                .then((response) => {
                    let { title, job_description, job_qualification, job_type, job_tenure, job_status, company_name, company_image_url, company_city, salary_min, salary_max } = response.data;

                    console.log(response);

                    setInput(
                        {
                            title: title,
                            job_description: job_description,
                            job_qualification: job_qualification,
                            job_type: job_type,
                            job_tenure: job_tenure,
                            job_status: job_status,
                            company_name: company_name,
                            company_image_url: company_image_url,
                            company_city: company_city,
                            salary_min: salary_min,
                            salary_max: salary_max
                        }
                    )
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    }, [IdData, setInput])

    return (
        <>
            <form onSubmit={handleSubmit}>
                <ToastContainer />
                <div className='w-11/12 h-42 bg-white rounded-xl shadow-lg p-10 ml-10'>
                    <div className="flex gap-x-7">
                        <div className='flex w-1/2 flex-col gap-y-5'>
                            <div>
                                <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Title</label>
                                <input onChange={handleInput} value={input.title} name='title' type="text" id="name" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5" />
                            </div>
                            <div>
                                <label htmlFor="company_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Company Name</label>
                                <input onChange={handleInput} value={input.company_name} name='company_name' type="text" id="company_name" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5" />
                            </div>
                            <div>
                                <label htmlFor="company_city" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">City</label>
                                <input onChange={handleInput} value={input.company_city} name='company_city' type="text" id="company_city" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5" />
                            </div>
                            <div>
                                <label htmlFor="job_type" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Type</label>
                                <input onChange={handleInput} value={input.job_type} name='job_type' type="text" id="job_type" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5" />
                            </div>
                            <div>
                                <label htmlFor="job_tenure" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Tenure</label>
                                <input onChange={handleInput} value={input.job_tenure} name='job_tenure' type="text" id="job_tenure" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5" />
                            </div>
                            <div>
                                <label htmlFor="salary_min" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Minimum Salary</label>
                                <input onChange={handleInput} value={input.salary_min} name='salary_min' type="number" id="salary_min" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5" />
                            </div>
                            <div>
                                <label htmlFor="salary_max" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Maximum Salary</label>
                                <input onChange={handleInput} value={input.salary_max} name='salary_max' type="number" id="salary_max" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5" />
                            </div>
                        </div>
                        <div className='flex flex-col w-1/2 gap-y-5'>
                            <div>
                                <label htmlFor="company_image_url" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Company Logo Image URL</label>
                                <input onChange={handleInput} value={input.company_image_url} name='company_image_url' type="text" id="company_image_url" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5" />
                            </div>
                            <div>
                                <label htmlFor="job_description" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Description</label>
                                <textarea onChange={handleInput} value={input.job_description} name='job_description' type="text" id="job_description" className="bg-gray-50 h-28 border resize-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5" />
                            </div>
                            <div>
                                <label htmlFor="job_qualification" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Qualification</label>
                                <textarea onChange={handleInput} value={input.job_qualification} name='job_qualification' type="text" id="job_qualification" className="bg-gray-50 h-24 border resize-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5" />
                            </div>
                            <div className='flex flex-col gap-y-3'>
                                <p className='font-medium text-sm'>Status</p>
                                <div className='flex gap-x-5'>
                                    <div className="flex items-center mb-4">
                                        <input onChange={handleInput} checked={input.job_status === 1} id="job-open" type="radio" value='1' name="job_status" className="w-4 h-4 focus:bg-sky-500 text-sky-600 bg-gray-100 border-gray-300 focus:ring-sky-500 focus:ring-2" />
                                        <label htmlFor="job-open" className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Open</label>
                                    </div>
                                    <div className="flex items-center mb-4">
                                        <input onChange={handleInput} checked={input.job_status === 0} id="job-closed" type="radio" value='0' name="job_status" className="w-4 h-4 focus:bg-sky-500 text-sky-600 bg-gray-100 border-gray-300 focus:ring-sky-500 focus:ring-2" />
                                        <label htmlFor="job-closed" className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Closed</label>
                                    </div>
                                </div>
                            </div>
                            <div className='flex justify-end mt-16'>
                                <button onClick={handleSubmit} type="button" className="text-white w-fit bg-sky-500 hover:bg-sky-600 focus:ring-4 focus:ring-sky-300 font-medium rounded-lg text-sm px-5 py-2.5 mt-5 mb-2 dark:bg-sky-600 dark:hover:bg-sky-700 focus:outline-none dark:focus:ring-sky-800">
                                    {IdData ? 'Update' : 'Post'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
}

export default Form;